import { render, staticRenderFns } from "./ls-dialog.vue?vue&type=template&id=b40ca40e&scoped=true"
import script from "./ls-dialog.vue?vue&type=script&lang=ts"
export * from "./ls-dialog.vue?vue&type=script&lang=ts"
import style0 from "./ls-dialog.vue?vue&type=style&index=0&id=b40ca40e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40ca40e",
  null
  
)

export default component.exports